module.exports = __webpack_public_path__ + "img/loginbg.1913e4ad.png";